.root {
  display: grid;
  gap: 8px;
  justify-content: center;
  margin-top: 16px;
  margin-right: auto;
  margin-left: auto;
}

.pressReleaseRoot {
  @container press-release-root (min-width:1024px) {
    display: none;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    display: none;
  }
}
